import request from '@/utils/request'

export const getContracts = params => request.get('/accounting/contracts', { params })

export const createContract = data => request.post('/accounting/contracts', data)

export const getContract = id => request.get(`/accounting/contracts/${id}`)

export const updateContract = (id, data) => request.put(`/accounting/contracts/${id}`, data)

export const createContractBilling = (id, data) => request.post(`/accounting/contracts/${id}/billings`, data)

export const handoverContract = (id, data) => request.post(`/accounting/contracts/${id}/handover`, data || {})

export const releaseContractRetention = (id, data) => request.post(`/accounting/contracts/${id}/release-retention`, data || {})
